import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function PlacesIcon({ className }: IconProps) {
  return (
    <svg
      width="145"
      height="94"
      viewBox="0 0 145 94"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2374)">
        <path
          d="M109.576 0H53.2765C51.186 0 49.4912 1.68643 49.4912 3.76675V80.5072C49.4912 82.5875 51.186 84.2739 53.2765 84.2739H109.576C111.667 84.2739 113.361 82.5875 113.361 80.5072V3.76675C113.361 1.68643 111.667 0 109.576 0Z"
          fill="#DDE0E7"
        />
        <path
          d="M86.5538 59.7057H76.3278C75.6216 59.7057 75.0566 59.1435 75.0566 58.4408V53.3528C75.0566 52.6501 75.6216 52.0879 76.3278 52.0879H86.5538C87.26 52.0879 87.825 52.6501 87.825 53.3528V58.4408C87.825 59.1435 87.26 59.7057 86.5538 59.7057Z"
          fill="#B0B9CF"
        />
        <path
          d="M104.124 59.7057H93.8981C93.1919 59.7057 92.627 59.1435 92.627 58.4408V53.3528C92.627 52.6501 93.1919 52.0879 93.8981 52.0879H104.124C104.83 52.0879 105.395 52.6501 105.395 53.3528V58.4408C105.395 59.1435 104.83 59.7057 104.124 59.7057Z"
          fill="#00416B"
        />
        <path
          d="M68.9825 59.7057H58.7565C58.0503 59.7057 57.4854 59.1435 57.4854 58.4408V53.3528C57.4854 52.6501 58.0503 52.0879 58.7565 52.0879H68.9825C69.6887 52.0879 70.2537 52.6501 70.2537 53.3528V58.4408C70.2537 59.1435 69.6887 59.7057 68.9825 59.7057Z"
          fill="#00416B"
        />
        <path
          d="M86.5538 44.9201H76.3278C75.6216 44.9201 75.0566 44.3579 75.0566 43.6551V38.5672C75.0566 37.8644 75.6216 37.3022 76.3278 37.3022H86.5538C87.26 37.3022 87.825 37.8644 87.825 38.5672V43.6551C87.825 44.3579 87.26 44.9201 86.5538 44.9201Z"
          fill="#00416B"
        />
        <path
          d="M104.124 44.9201H93.8981C93.1919 44.9201 92.627 44.3579 92.627 43.6551V38.5672C92.627 37.8644 93.1919 37.3022 93.8981 37.3022H104.124C104.83 37.3022 105.395 37.8644 105.395 38.5672V43.6551C105.395 44.3579 104.83 44.9201 104.124 44.9201Z"
          fill="#00C4B3"
        />
        <path
          d="M68.9825 44.9201H58.7565C58.0503 44.9201 57.4854 44.3579 57.4854 43.6551V38.5672C57.4854 37.8644 58.0503 37.3022 58.7565 37.3022H68.9825C69.6887 37.3022 70.2537 37.8644 70.2537 38.5672V43.6551C70.2537 44.3579 69.6887 44.9201 68.9825 44.9201Z"
          fill="#00C4B3"
        />
        <path
          d="M86.5538 29.8249H76.3278C75.6216 29.8249 75.0566 29.2627 75.0566 28.5599V23.472C75.0566 22.7692 75.6216 22.207 76.3278 22.207H86.5538C87.26 22.207 87.825 22.7692 87.825 23.472V28.5599C87.825 29.2627 87.26 29.8249 86.5538 29.8249Z"
          fill="#00416B"
        />
        <path
          d="M104.124 29.8249H93.8981C93.1919 29.8249 92.627 29.2627 92.627 28.5599V23.472C92.627 22.7692 93.1919 22.207 93.8981 22.207H104.124C104.83 22.207 105.395 22.7692 105.395 23.472V28.5599C105.395 29.2627 104.83 29.8249 104.124 29.8249Z"
          fill="#B0B9CF"
        />
        <path
          d="M68.9825 29.8249H58.7565C58.0503 29.8249 57.4854 29.2627 57.4854 28.5599V23.472C57.4854 22.7692 58.0503 22.207 58.7565 22.207H68.9825C69.6887 22.207 70.2537 22.7692 70.2537 23.472V28.5599C70.2537 29.2627 69.6887 29.8249 68.9825 29.8249Z"
          fill="#B0B9CF"
        />
        <path
          d="M86.5538 14.7296H76.3278C75.6216 14.7296 75.0566 14.1674 75.0566 13.4647V8.37677C75.0566 7.67402 75.6216 7.11182 76.3278 7.11182H86.5538C87.26 7.11182 87.825 7.67402 87.825 8.37677V13.4647C87.825 14.1674 87.26 14.7296 86.5538 14.7296Z"
          fill="#B0B9CF"
        />
        <path
          d="M104.124 14.7296H93.8981C93.1919 14.7296 92.627 14.1674 92.627 13.4647V8.37677C92.627 7.67402 93.1919 7.11182 93.8981 7.11182H104.124C104.83 7.11182 105.395 7.67402 105.395 8.37677V13.4647C105.395 14.1674 104.83 14.7296 104.124 14.7296Z"
          fill="#00C4B3"
        />
        <path
          d="M68.9825 14.7296H58.7565C58.0503 14.7296 57.4854 14.1674 57.4854 13.4647V8.37677C57.4854 7.67402 58.0503 7.11182 58.7565 7.11182H68.9825C69.6887 7.11182 70.2537 7.67402 70.2537 8.37677V13.4647C70.2537 14.1674 69.6887 14.7296 68.9825 14.7296Z"
          fill="#00416B"
        />
        <path
          d="M79.9715 84.2738H52.4009C50.7907 84.2738 49.5195 82.9526 49.5195 81.3223V81.1255H83.0506C83.0506 82.8683 81.6664 84.2738 79.9715 84.2738Z"
          fill="#B0B9CF"
        />
        <path
          d="M110.31 84.2738H82.7398C81.1296 84.2738 79.8584 82.9526 79.8584 81.3223V81.1255H113.389C113.389 82.8683 112.005 84.2738 110.31 84.2738Z"
          fill="#B0B9CF"
        />
        <path
          d="M84.9718 66.7334H77.9379C76.9775 66.7334 76.1865 67.5205 76.1865 68.4762V84.246H86.7515V68.4762C86.7515 67.5205 85.9605 66.7334 85.0001 66.7334H84.9718Z"
          fill="#00416B"
        />
        <path
          d="M104.633 65.0469H93.3897C92.9684 65.0469 92.627 65.3867 92.627 65.8058V75.8692C92.627 76.2884 92.9684 76.6282 93.3897 76.6282H104.633C105.054 76.6282 105.395 76.2884 105.395 75.8692V65.8058C105.395 65.3867 105.054 65.0469 104.633 65.0469Z"
          fill="#B0B9CF"
        />
        <path
          d="M69.491 65.0469H58.2481C57.8268 65.0469 57.4854 65.3867 57.4854 65.8058V75.8692C57.4854 76.2884 57.8268 76.6282 58.2481 76.6282H69.491C69.9122 76.6282 70.2537 76.2884 70.2537 75.8692V65.8058C70.2537 65.3867 69.9122 65.0469 69.491 65.0469Z"
          fill="#B0B9CF"
        />
        <path
          d="M60.0847 9.72607H3.78531C1.69474 9.72607 0 11.4125 0 13.4928V90.2333C0 92.3136 1.69474 94 3.78531 94H60.0847C62.1753 94 63.8701 92.3136 63.8701 90.2333V13.4928C63.8701 11.4125 62.1753 9.72607 60.0847 9.72607Z"
          fill="#EAEDF8"
        />
        <path
          d="M37.0343 69.4318H26.8083C26.1021 69.4318 25.5371 68.8696 25.5371 68.1668V63.0789C25.5371 62.3762 26.1021 61.814 26.8083 61.814H37.0343C37.7405 61.814 38.3055 62.3762 38.3055 63.0789V68.1668C38.3055 68.8696 37.7405 69.4318 37.0343 69.4318Z"
          fill="#DDE0E7"
        />
        <path
          d="M54.6046 69.4318H44.3786C43.6724 69.4318 43.1074 68.8696 43.1074 68.1668V63.0789C43.1074 62.3762 43.6724 61.814 44.3786 61.814H54.6046C55.3108 61.814 55.8758 62.3762 55.8758 63.0789V68.1668C55.8758 68.8696 55.3108 69.4318 54.6046 69.4318Z"
          fill="#00416B"
        />
        <path
          d="M19.4913 69.4318H9.26533C8.55911 69.4318 7.99414 68.8696 7.99414 68.1668V63.0789C7.99414 62.3762 8.55911 61.814 9.26533 61.814H19.4913C20.1975 61.814 20.7625 62.3762 20.7625 63.0789V68.1668C20.7625 68.8696 20.1975 69.4318 19.4913 69.4318Z"
          fill="#00416B"
        />
        <path
          d="M37.0343 54.6461H26.8083C26.1021 54.6461 25.5371 54.0839 25.5371 53.3812V48.2933C25.5371 47.5905 26.1021 47.0283 26.8083 47.0283H37.0343C37.7405 47.0283 38.3055 47.5905 38.3055 48.2933V53.3812C38.3055 54.0839 37.7405 54.6461 37.0343 54.6461Z"
          fill="#00416B"
        />
        <path
          d="M54.6046 54.6461H44.3786C43.6724 54.6461 43.1074 54.0839 43.1074 53.3812V48.2933C43.1074 47.5905 43.6724 47.0283 44.3786 47.0283H54.6046C55.3108 47.0283 55.8758 47.5905 55.8758 48.2933V53.3812C55.8758 54.0839 55.3108 54.6461 54.6046 54.6461Z"
          fill="#00C4B3"
        />
        <path
          d="M19.4913 54.6461H9.26533C8.55911 54.6461 7.99414 54.0839 7.99414 53.3812V48.2933C7.99414 47.5905 8.55911 47.0283 9.26533 47.0283H19.4913C20.1975 47.0283 20.7625 47.5905 20.7625 48.2933V53.3812C20.7625 54.0839 20.1975 54.6461 19.4913 54.6461Z"
          fill="#00C4B3"
        />
        <path
          d="M37.0343 39.5509H26.8083C26.1021 39.5509 25.5371 38.9887 25.5371 38.286V33.1981C25.5371 32.4953 26.1021 31.9331 26.8083 31.9331H37.0343C37.7405 31.9331 38.3055 32.4953 38.3055 33.1981V38.286C38.3055 38.9887 37.7405 39.5509 37.0343 39.5509Z"
          fill="#00416B"
        />
        <path
          d="M54.6046 39.5509H44.3786C43.6724 39.5509 43.1074 38.9887 43.1074 38.286V33.1981C43.1074 32.4953 43.6724 31.9331 44.3786 31.9331H54.6046C55.3108 31.9331 55.8758 32.4953 55.8758 33.1981V38.286C55.8758 38.9887 55.3108 39.5509 54.6046 39.5509Z"
          fill="#DDE0E7"
        />
        <path
          d="M19.4913 39.5509H9.26533C8.55911 39.5509 7.99414 38.9887 7.99414 38.286V33.1981C7.99414 32.4953 8.55911 31.9331 9.26533 31.9331H19.4913C20.1975 31.9331 20.7625 32.4953 20.7625 33.1981V38.286C20.7625 38.9887 20.1975 39.5509 19.4913 39.5509Z"
          fill="#DDE0E7"
        />
        <path
          d="M37.0343 24.4557H26.8083C26.1021 24.4557 25.5371 23.8935 25.5371 23.1908V18.1028C25.5371 17.4001 26.1021 16.8379 26.8083 16.8379H37.0343C37.7405 16.8379 38.3055 17.4001 38.3055 18.1028V23.1908C38.3055 23.8935 37.7405 24.4557 37.0343 24.4557Z"
          fill="#DDE0E7"
        />
        <path
          d="M54.6046 24.4557H44.3786C43.6724 24.4557 43.1074 23.8935 43.1074 23.1908V18.1028C43.1074 17.4001 43.6724 16.8379 44.3786 16.8379H54.6046C55.3108 16.8379 55.8758 17.4001 55.8758 18.1028V23.1908C55.8758 23.8935 55.3108 24.4557 54.6046 24.4557Z"
          fill="#00C4B3"
        />
        <path
          d="M19.4913 24.4557H9.26533C8.55911 24.4557 7.99414 23.8935 7.99414 23.1908V18.1028C7.99414 17.4001 8.55911 16.8379 9.26533 16.8379H19.4913C20.1975 16.8379 20.7625 17.4001 20.7625 18.1028V23.1908C20.7625 23.8935 20.1975 24.4557 19.4913 24.4557Z"
          fill="#00416B"
        />
        <path
          d="M30.452 93.9999H2.88136C1.27119 93.9999 0 92.6787 0 91.0483V90.8516H33.5311C33.5311 92.5944 32.1469 93.9999 30.452 93.9999Z"
          fill="#DDE0E7"
        />
        <path
          d="M60.7908 93.9999H33.2202C31.6101 93.9999 30.3389 92.6787 30.3389 91.0483V90.8516H63.8699C63.8699 92.5944 62.4858 93.9999 60.7908 93.9999Z"
          fill="#DDE0E7"
        />
        <path
          d="M35.4523 76.4873H28.4184C27.458 76.4873 26.667 77.2744 26.667 78.2301V93.9999H37.232V78.2301C37.232 77.2744 36.441 76.4873 35.4806 76.4873H35.4523Z"
          fill="#00416B"
        />
        <path
          d="M55.1131 74.7729H43.8701C43.4489 74.7729 43.1074 75.1128 43.1074 75.5319V85.5953C43.1074 86.0145 43.4489 86.3543 43.8701 86.3543H55.1131C55.5343 86.3543 55.8758 86.0145 55.8758 85.5953V75.5319C55.8758 75.1128 55.5343 74.7729 55.1131 74.7729Z"
          fill="#DDE0E7"
        />
        <path
          d="M19.9998 74.7729H8.75685C8.33562 74.7729 7.99414 75.1128 7.99414 75.5319V85.5953C7.99414 86.0145 8.33562 86.3543 8.75685 86.3543H19.9998C20.421 86.3543 20.7625 86.0145 20.7625 85.5953V75.5319C20.7625 75.1128 20.421 74.7729 19.9998 74.7729Z"
          fill="#DDE0E7"
        />
        <path
          d="M135.368 93.9998H102.882C100.792 93.9998 99.125 92.3132 99.125 90.2612V46.2128C99.125 44.1326 100.82 42.4741 102.882 42.4741H135.368C137.458 42.4741 139.125 44.1607 139.125 46.2128V90.2612C139.125 92.3413 137.43 93.9998 135.368 93.9998Z"
          fill="#E8ECF7"
        />
        <path
          d="M135.453 93.9999H102.571C100.679 93.9999 99.125 92.4257 99.125 90.4861V90.2612H139.153C139.153 92.3414 137.515 93.9999 135.481 93.9999"
          fill="#00C4B3"
        />
        <path
          d="M139.125 55.5736H99.0967V44.7231C99.0967 42.5305 100.905 40.7314 103.108 40.7314H135.114C137.317 40.7314 139.125 42.5024 139.125 44.7231V55.5736Z"
          fill="#E8ECF7"
        />
        <path
          d="M133.503 71.5117H119.35C118.835 71.5117 118.418 71.927 118.418 72.4394V85.117C118.418 85.6293 118.835 86.0446 119.35 86.0446H133.503C134.018 86.0446 134.435 85.6293 134.435 85.117V72.4394C134.435 71.927 134.018 71.5117 133.503 71.5117Z"
          fill="white"
        />
        <path
          d="M133.475 70.5845H119.351C118.305 70.5845 117.458 71.4278 117.458 72.4678V85.1174C117.458 86.1574 118.305 87.0007 119.351 87.0007H133.475C134.52 87.0007 135.368 86.1574 135.368 85.1174V72.4678C135.368 71.4278 134.52 70.5845 133.475 70.5845ZM133.475 85.1174H119.351V72.4678H133.475V85.1174Z"
          fill="#00416B"
        />
        <path
          d="M103.814 93.9998V72.4394C103.814 71.9334 104.238 71.5117 104.747 71.5117H111.809C112.317 71.5117 112.741 71.9334 112.741 72.4394V93.9998H103.786H103.814Z"
          fill="white"
        />
        <path
          d="M111.808 70.5845H104.746C103.701 70.5845 102.854 71.4278 102.854 72.4678V94.0283H104.746V72.4678H111.808V94.0283H113.701V72.4678C113.701 71.4278 112.854 70.5845 111.808 70.5845Z"
          fill="#00416B"
        />
        <path
          d="M99.3506 66.3679H97.458C95.1134 66.3679 93.2207 64.4845 93.2207 62.1514H103.588C103.588 64.4845 101.695 66.3679 99.3506 66.3679Z"
          fill="#00416B"
        />
        <path
          d="M109.69 66.3679H107.797C105.452 66.3679 103.56 64.4845 103.56 62.1514H113.927C113.927 64.4845 112.034 66.3679 109.69 66.3679Z"
          fill="#00C4B3"
        />
        <path
          d="M120.057 66.3679H118.164C115.819 66.3679 113.927 64.4845 113.927 62.1514H124.294C124.294 64.4845 122.401 66.3679 120.057 66.3679Z"
          fill="#00416B"
        />
        <path
          d="M130.424 66.3679H128.531C126.187 66.3679 124.294 64.4845 124.294 62.1514H134.661C134.661 64.4845 132.769 66.3679 130.424 66.3679Z"
          fill="#00C4B3"
        />
        <path
          d="M140.763 66.3679H138.87C136.525 66.3679 134.633 64.4845 134.633 62.1514H145C145 64.4845 143.107 66.3679 140.763 66.3679Z"
          fill="#00416B"
        />
        <path
          d="M139.124 55.5737H131.61L134.661 62.1515H145L139.124 55.5737Z"
          fill="#00416B"
        />
        <path
          d="M106.639 55.5737L103.588 62.1515H113.927L115.255 55.5737H106.639Z"
          fill="#00C4B3"
        />
        <path
          d="M122.967 55.5737L124.294 62.1515H134.662L131.611 55.5737H122.967Z"
          fill="#00C4B3"
        />
        <path
          d="M99.0964 55.5737L93.2207 62.1515H103.588L106.639 55.5737H99.0964Z"
          fill="#00416B"
        />
        <path
          d="M115.254 55.5737L113.927 62.1515H124.294L122.966 55.5737H115.254Z"
          fill="#00416B"
        />
        <path
          d="M135.227 46.4097C134.634 46.4097 134.182 46.8875 134.182 47.4497C134.182 48.0119 134.662 48.4898 135.227 48.4898C135.792 48.4898 136.272 48.0119 136.272 47.4497C136.272 46.8875 135.792 46.4097 135.227 46.4097ZM135.001 47.3092C135.001 47.3092 134.831 47.3935 134.831 47.4778V47.7871V47.8152H134.662V47.1124H134.831C134.831 47.1124 134.944 47.1124 135.001 47.1124V47.2811V47.3092ZM135.905 47.4778V47.8152H135.735V47.4778C135.735 47.4778 135.651 47.3092 135.566 47.3092C135.481 47.3092 135.396 47.3935 135.396 47.4778V47.8152H135.227V46.7189H135.396V47.1405C135.396 47.1405 135.509 47.0843 135.566 47.0843C135.764 47.0843 135.933 47.253 135.933 47.4497"
          fill="#00C4B3"
        />
        <path
          d="M117.288 47.7027C117.995 47.7027 118.588 48.293 118.588 48.9958C118.588 49.6985 117.995 50.2889 117.288 50.2889C116.582 50.2889 115.989 49.6985 115.989 48.9958C115.989 48.293 116.582 47.7027 117.288 47.7027ZM117.288 46.4097C115.848 46.4097 114.689 47.5622 114.689 48.9958C114.689 50.4294 115.848 51.5819 117.288 51.5819C118.729 51.5819 119.887 50.4294 119.887 48.9958C119.887 47.5622 118.729 46.4097 117.288 46.4097Z"
          fill="#00416B"
        />
        <path
          d="M112.882 51.4975H111.554L109.718 46.4658H111.158L112.232 49.6423L113.277 46.4658H114.718L112.882 51.4975Z"
          fill="#00416B"
        />
        <path
          d="M126.131 51.4975H124.803L122.967 46.4658H124.407L125.453 49.6423L126.526 46.4658H127.967L126.131 51.4975Z"
          fill="#00416B"
        />
        <path
          d="M109.747 49.4735V49.0237V48.9675V48.9394C109.718 47.5339 108.56 46.3813 107.148 46.3813C105.735 46.3813 104.549 47.5339 104.549 48.9675C104.549 50.4011 105.707 51.5536 107.148 51.5536C107.91 51.5536 108.588 51.2163 109.069 50.7103L108.136 49.7827C107.91 50.0638 107.543 50.2324 107.148 50.2324C106.611 50.2324 106.131 49.8951 105.933 49.4172H109.747V49.4735ZM107.148 47.7025C107.684 47.7025 108.165 48.0398 108.362 48.5177H105.961C106.159 48.0398 106.611 47.7025 107.176 47.7025"
          fill="#00416B"
        />
        <path
          d="M133.193 49.4735V49.0237V48.9675V48.9394C133.165 47.5339 132.006 46.3813 130.594 46.3813C129.182 46.3813 127.995 47.5339 127.995 48.9675C127.995 50.4011 129.153 51.5536 130.594 51.5536C131.357 51.5536 132.035 51.2163 132.515 50.7103L131.583 49.7827C131.357 50.0638 130.989 50.2324 130.594 50.2324C130.057 50.2324 129.577 49.8951 129.379 49.4172H133.193V49.4735ZM130.594 47.7025C131.131 47.7025 131.611 48.0398 131.809 48.5177H129.408C129.605 48.0398 130.057 47.7025 130.622 47.7025"
          fill="#00416B"
        />
        <path
          d="M121.78 49.024V43.6831H120.48V48.9959C120.48 48.9959 120.48 48.9959 120.48 49.024C120.48 49.0521 120.48 49.024 120.48 49.0521C120.48 50.4576 121.61 51.582 123.023 51.6101V50.3171C122.345 50.289 121.808 49.7268 121.808 49.0521"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2374">
          <rect width="145" height="94" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
